import { t } from "i18next";
import toast from "react-hot-toast";
import BasicDialog from "../../components/base/BasicDialog";
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import { useToasts } from "../../hooks/useToasts";
import { useGetPersonClauses } from "../../services/clausesService";
import {
    useEditLeadMutation,
    useEditLeadPersonMutation,
    useLeadFailureReasons,
    useLeadsSourceChannels,
    useLeadsStatuses,
} from "../../services/leadsService";
import { useGetSellers } from "../../services/usersApi";
import { LeadForm } from "./LeadForm";
import { useInvestments } from "../../services/productsService";

export function LeadEditDialog(props) {
    const { mutate: editLeadLead, isPending } = useEditLeadMutation({
        onSuccess: () => {
            toast.custom(
                () => (
                    <SnackbarSuccess message={t("lead.editLeadForm.editedLeadLeadSuccessfully")} />
                ),
                {
                    position: "bottom-right",
                },
            );
            props.onClose();
        },
    });

    const { mutate: editLeadPerson } = useEditLeadPersonMutation({
        onSuccess: () => {
            toast.custom(
                () => (
                    <SnackbarSuccess
                        message={t("lead.editLeadForm.editedLeadPersonSuccessfully")}
                    />
                ),
                {
                    position: "bottom-right",
                },
            );
            props.onClose();
        },
    });

    function editWholeLead(lead, person, person_id, lead_id) {
        editLeadPerson({ personId: person_id, leadPerson: person });

        editLeadLead({
            leadId: lead_id,
            lead: lead,
        });
    }

    const { data: personClauses } = useGetPersonClauses(props.lead.person.id, {
        select: (data) => data.results,
    });

    const { data: leadsSourceChannels } = useLeadsSourceChannels({
        select: (data) =>
            data.results.map((channel) => ({
                value: channel.channel_name_eng,
                label: t(`lead.sources.${channel.channel_name_eng}`),
            })),
    });
    const { data: leadsStatuses } = useLeadsStatuses({
        select: (data) =>
            data.results.map((status) => ({
                value: status.status_name_eng,
                label: t(`lead.status.${status.status_name_eng}`),
            })),
    });
    const { data: sellers } = useGetSellers({
        select: (data) =>
            data.map((seller) => ({
                value: seller.id,
                label: seller.full_name,
            })),
    });

    const { data: failureReasons } = useLeadFailureReasons({
        select: (data) =>
            data.results.map((reason) => ({
                value: reason.reason_name_eng,
                label: t(`lead.reasons.${reason.reason_name_eng}`),
            })),
    });

    const { data: investments } = useInvestments({
        select: (data) =>
            data.results.map((investment) => ({
                value: investment.id,
                label: investment.investment_name_sales,
            })),
    });

    const { onFormErrors } = useToasts();

    if (
        !leadsSourceChannels ||
        !leadsStatuses ||
        !sellers ||
        !personClauses ||
        !failureReasons ||
        !investments
    ) {
        return null;
    }

    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("lead.editLeadForm.title")}
            maxWidth={"sm"}
            showDialogActions
        >
            <LeadForm
                submitBtnText={t("saveChanges")}
                leadsSourceChannels={leadsSourceChannels}
                leadsStatuses={leadsStatuses}
                failureReasons={failureReasons}
                investments={investments}
                sellers={sellers}
                isEditMode={true}
                onSubmit={(form) =>
                    editWholeLead(
                        {
                            leadSource: form.leadSource,
                            leadStatus: form.leadStatus,
                            leadStatus: form.leadStatus,
                            statusNote: form.statusNote,
                            leadStatusReason: form.statusReason || "",
                            leadInvestment: form.leadInvestment,
                            sellerComment: form.sellerComment,
                            person_id: props.lead.person.id,
                            seller_id: form.leadCaretakerId,
                            productIds: form.productIds,
                        },
                        {
                            personEmail: form.personEmail || "",
                            personName: form.personName,
                            personSurname: form.personSurname,
                            personPhone: form.personPhone || "",
                        },
                        props.lead.person.id,
                        props.lead.lead.id,
                    )
                }
                onError={onFormErrors}
                defaultValues={{
                    leadSource: props.lead.lead.lead_source || "",
                    leadStatus: props.lead.lead.lead_status || "",
                    leadInvestment: props.lead.lead.lead_invest || "",
                    statusReason: props.lead.lead.lead_status_reason || "",
                    statusNote: props.lead.lead.lead_status_note || "",
                    personName: props.lead.person.person_name || "",
                    personSurname: props.lead.person.person_surname || "",
                    personPhone: props.lead.person.phone.phone_number || "",
                    personEmail: props.lead.person.email.email_address || "",
                    authorComment: props.lead.lead.lead_note_from_source || "",
                    sellerComment: props.lead.lead.lead_note_from_sales || "",
                    leadCaretakerId: props.lead.lead.lead_seller?.id ?? "",
                    
                    productIds: props.lead.lead.products.map((product) => product.id),
                }}
                isLoading={isPending} 
            />
        </BasicDialog>
    );
}
